import { ChangeDetectionStrategy, Component, OnDestroy, OnInit } from '@angular/core';
import { PopupCustomComponentGeneric } from 'src/app/popup-custom/popup-custom-content.component';
import { RestaurantModel } from 'src/app/shared/models/restaurant.model';
import { OdgConviveModel, OdgPrestationModel } from '../models/odg.model';
import { OdgService } from '../services/odg.service';
import { ReportingService } from 'src/app/reporting/services/reporting.service';
import { InteractionService } from 'src/app/shared/services/interaction.service';
import { ContratModel } from 'src/app/shared/models/contrat.model';

export class OdgExportFichesEvalutationsModel {

  public readonly periodeLabel: string;
  public readonly contratLabel: string;
  public readonly restaurantLabel: string | null;
  public readonly restaurantId: number | null;
  public readonly conviveLabel: string | null;
  public readonly conviveId: number | null;
  public readonly prestationLabel: string | null;
  public readonly prestationId: number | null;

  public readonly onExport: (params: OdgExportFichesEvalutationsModel) => void;


  public selectedRestaurantId: number | null;
  public selectedConviveId: number | null;
  public selectedPrestationId: number | null;

  constructor(periodeLabel: string, contrat: ContratModel, restaurant: RestaurantModel | null, convive: OdgConviveModel | null, prestation: OdgPrestationModel | null, onExport: (params: OdgExportFichesEvalutationsModel) => void) {
    this.periodeLabel = periodeLabel;
    this.contratLabel = contrat.libelle;
    this.restaurantLabel = restaurant ? restaurant.name : null;
    this.selectedRestaurantId = this.restaurantId = (restaurant ? restaurant.id : null);
    this.conviveLabel = convive ? convive.libelle : null;
    this.selectedConviveId = this.conviveId = (convive ? convive.id : null);
    this.prestationLabel = prestation ? prestation.libelle : null;
    this.selectedPrestationId = this.prestationId = (prestation ? prestation.id : null);
    this.onExport = onExport;
  }

}


@Component({
  selector: 'app-odg-export-fiches-evalutations',
  templateUrl: './odg-export-fiches-evalutations.component.html',
  styleUrls: ['./odg-export-fiches-evalutations.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class OdgExportFichesEvalutationsComponent extends PopupCustomComponentGeneric<OdgExportFichesEvalutationsModel> implements OnInit, OnDestroy {

  public isSending: boolean;

  //#region data property override
  private _data: any;
  public get data(): any {
    return this._data;
  }
  public set data(data: any) {
    if (data !== this._data) {
      this._data = data;
    }
  }
  //#endregion

  constructor(
    // private _odgService: OdgService,
    // private _reportingService: ReportingService,
    // private _interactionService: InteractionService
  ) {
    super();
  }

  ngOnInit() {
  }

  ngOnDestroy() {
  }

  public close() {
    this.emitter.next();
  }

  public export() {
    this.model.onExport(this.model);
    this.close();
  }

  public selectRestaurantId(restaurantId: number | null) {
    this.model.selectedRestaurantId = restaurantId;
  }

  public selectConviveId(conviveId: number | null) {
    this.model.selectedConviveId = conviveId;
  }

  public selectPrestationId(prestationId: number | null) {
    this.model.selectedPrestationId = prestationId;
  }

}
